export default {
  GET_REFRESH_TOKEN: 'api-management/GET_REFRESH_TOKEN',
  SET_REFRESH_TOKEN: 'api-management/SET_REFRESH_TOKEN',
  SET_STATUS_REFRESH_TOKEN: 'api-management/SET_STATUS_REFRESH_TOKEN',
  SET_ERROR_REFRESH_TOKEN: 'api-management/SET_ERROR_REFRESH_TOKEN',
  GENERATE_REFRESH_TOKEN: 'api-management/GENERATE_REFRESH_TOKEN',
};
